export default "__VITE_PUBLIC_ASSET__38bb49a1__"